module.exports = __webpack_public_path__ + "static/media/product-4.63e7aa40.png";